/* src/app/modules/expense/selfemployed/selfemployed.component.css */
:host ::ng-deep .se-field-full {
  width: 100% !important;
}
.se-form {
  padding-bottom: 2rem;
}
.tf-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0 1.25rem;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 1.5rem;
}
.tf-page-title {
  font-weight: 700;
  font-size: 1.4rem;
  color: #1f2937;
  margin: 0;
}
.tf-card mat-card-content {
  padding: 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 1rem;
  color: #1f2937;
  margin: 0;
}
.se-euro-icon {
  font-size: 17px;
  color: #9ca3af;
}
/*# sourceMappingURL=selfemployed.component.css.map */
